import { render, staticRenderFns } from "./PaymentTotals.vue?vue&type=template&id=a8bdb926&"
import script from "./PaymentTotals.vue?vue&type=script&lang=js&"
export * from "./PaymentTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports